

import { useState } from "react";
import Config from "../../Config";
import Account from "./Account";
import Support from "./Support";

 

//import Wall from "../../news/Wall"
 




function HomeView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);  
    }


    var tab1 = " m_item ";
    var tab2 = " m_item ";
 

    if(props.mainView.viewSelected == "account") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "support") tab2 = tab2 + " selected";
 

    var subMenu = <div className="submenu">
            <div className={tab1} module="homeE" view="account" id="" onClick={props.mainView.quickGo} >Ustawienia konta</div>   
            <div className={tab2} module="homeE" view="support" id="" onClick={props.mainView.quickGo} >Wsparcie techniczne</div>   
    
    </div>
 
 

    if(props.mainView.viewSelected == 'account')
    {
        document.title =   props.userData.dic.forParents + " / "  + props.userData.dic.mSettings ;   

        return (
            <div className="econtent ">                           
           
                   {subMenu} 
                    <Account  userData={props.userData}  mainView={props.mainView}  />                  
             </div>
        )
    }


 
    
    if(props.mainView.viewSelected == 'support')
        {
            document.title =   props.userData.dic.forParents + " / "  + props.userData.dic.mSettings ;   
    
            return (
                <div className="econtent ">                           
               
                       {subMenu} 
                        <Support  userData={props.userData}  mainView={props.mainView}  />                  
                 </div>
            )
        }
 
                
                

    return (
        <div className="econtent ">
             {props.mainView.viewSelected}
        </div>
    );
}

export default HomeView ;